__turbopack_context__.v({
  "divider": "divider-module-scss-module__dQ9i2W__divider",
});
